export default {
  pt: {
    title: "Parabéns! Pode pedalar tranquilo!",
    description1: "Agora sua bicicleta está conectada com um universo de serviços e benefícios!",
    description2: "Você receberá um e-mail em {email} com todas as informações necessárias.",
    deferredTitle: "Agora falta apenas a inspeção!",
    deferredDescription1:
      "Para ativar sua cobertura, realize a inspeção da bicicleta em até 48 horas.",
    deferredDescription2: "Você receberá um e-mail com o link para finalizar a contratação.",
    qrCodeSubtitle: "Acesse pelo QR-Code",
    copyLinkButton: "Copiar link da jornada",
    copyLinkSuccessTitle: "Link copiado!",
    copyLinkSuccessDescription: "Cole o link no navegador do seu celular para continuar.",
    copyLinkErrorTitle: "Não foi possível copiar",
    copyLinkErrorDescription: "Tente novamente ou use o QR-Code.",
    experienceTitle: "Como foi a sua experiência?",
    experienceSubtitle: "Escolha de 1 a 5 estrelas para classificar",
    doubtsButton: "Dúvidas? Fala com a gente!",
    closeButton: "Fechar",
    commentTitle: "Deixe seu comentário",
    commentPlaceholder: "Escreva aqui...",
    commentMessage: "Nós valorizamos suas opiniões, sugestões e feedbacks! ☺️",
    sendButton: "Enviar",
    sendWithoutCommentButton: "Avaliar sem comentar",
  },

  en: {
    title: "Congratulations! You can ride safely!",
    description1: "Now your bicycle is connected to a universe of services and benefits!",
    description2: "You will receive an email at {email} with all necessary information.",
    deferredTitle: "Now only the inspection is left!",
    deferredDescription1: "To activate your coverage, inspect your bicycle within 48 hours.",
    deferredDescription2: "You will receive an email with the link to complete the purchase.",
    qrCodeSubtitle: "Access via QR-Code",
    copyLinkButton: "Copy journey link",
    copyLinkSuccessTitle: "Link copied!",
    copyLinkSuccessDescription: "Paste the link in your phone's browser to continue.",
    copyLinkErrorTitle: "Couldn't copy",
    copyLinkErrorDescription: "Try again or use the QR-Code.",
    experienceTitle: "How was your experience?",
    experienceSubtitle: "Choose from 1 to 5 stars to rate",
    doubtsButton: "Questions? Talk to us!",
    closeButton: "Close",
    commentTitle: "Leave your comment",
    commentPlaceholder: "Write here...",
    commentMessage: "We value your opinions, suggestions and feedback! ☺️",
    sendButton: "Send",
    sendWithoutCommentButton: "Rate without commenting",
  },
};
